import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Autocomplete} from "@material-ui/lab";
import {observacionesResources} from "../endpoints";

class DialogAgregarEditarObservacion extends React.Component{
    constructor(props) {
        super(props);
        if(props.observacion === null){
            if(props.usuario){
                this.state={
                    title:props.title,
                    prioridades:[],
                    detalle:"",
                    prioridad:null,
                    usuario:null,
                    usuarios:[]
                }
            }
            else{
                this.state={
                    title:props.title,
                    prioridades:[],
                    detalle:"",
                    prioridad:null
                }
            }
        }
        else{
            this.state={
                id:props.observacion.id,
                title:props.title,
                prioridades:[],
                detalle:props.observacion.texto,
                id_prioridad: props.observacion.id_prioridad,
                prioridad:null
            }
        }
    }

    getPrioridades = () =>{
        observacionesResources.getPrioridadesObs().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({prioridades:result})
            if(this.props.title === "Editar observación general"){
                this.getSelectedItem(this.state.prioridades)
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    get_usuario_observacion = ()=>{
        observacionesResources.getUsuarioObservacion().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({usuarios:result})
            }
        ).catch(error=> {
            console.log(error)
        });
    }

    getSelectedItem =(prioridades)=>{
        for (var i =0;i<prioridades.length;i++){
            if(prioridades[i].id === this.state.id_prioridad){
                this.setState({prioridad:prioridades[i]})
            }
        }
    }

    editarObservacion = () =>{
        const datosObservacion={
            texto: this.state.detalle,
            id_prioridad: this.state.prioridad.id
        }
        observacionesResources.editarObservacion(datosObservacion,this.state.id).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
        });
    }

    agregarObservacion = () =>{
        const datosObservacion={
            texto: this.state.detalle,
            id_prioridad: this.state.prioridad.id
        }
        observacionesResources.createObservacion(datosObservacion).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
        });
    }

    agregarObservacionUsuario = () =>{
        const datosObservacionUsuario={
            texto: this.state.detalle,
            id_prioridad: this.state.prioridad.id,
            usuario: this.state.usuario.usuario
        }
        observacionesResources.createObservacionUsuario(datosObservacionUsuario).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
        });
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value})
    };

    componentDidMount() {
        this.getPrioridades()
        this.get_usuario_observacion()
    }

    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.state.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            <TextField
                                id="standard-multiline-flexible"
                                label="Detalle"
                                multiline
                                fullWidth
                                rowsMax={5}
                                name={"detalle"}
                                value={this.state.detalle}
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            Seleccione una prioridad:
                            <Autocomplete
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({prioridad: null})
                                    }
                                    else{
                                        this.setState({prioridad: newValue})
                                    }
                                }}
                                size="small"
                                options={this.state.prioridades}
                                value={this.state.prioridad}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.descripcion|| ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Prioridad" placeholder="Disponibles" />
                                )}
                            />
                        </Grid>
                        {
                            this.props.usuario &&
                            <Grid item xs={12}>
                                Seleccione usuario:
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({usuario: null})
                                        }
                                        else{
                                            this.setState({usuario: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.usuarios}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.nombre|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Usuario" placeholder="Disponibles" />
                                    )}
                                />
                            </Grid>
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    {
                        this.state.title === "Editar observación general" && <Button disabled={!this.state.detalle || !this.state.prioridad} variant="contained" color="primary"  onClick={this.editarObservacion}>
                        Guardar
                        </Button>
                    }
                    {
                        this.state.title === "Agregar observación general" && <Button disabled={!this.state.detalle || !this.state.prioridad} variant="contained" color="primary" onClick={this.agregarObservacion}>
                            Guardar
                        </Button>
                    }
                    {
                        this.state.title ==="Agregar observación de usuario" &&
                        <Button disabled={!this.state.detalle || !this.state.prioridad || !this.state.usuario} variant="contained" color="primary" onClick={this.agregarObservacionUsuario}>
                            Guardar
                        </Button>
                    }


                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogAgregarEditarObservacion;